import { Boolean, Number, Record, Static, String } from 'runtypes';

import { createEnumGuard } from 'src/models/enumGuard';
import { StatusEnum as _Status } from 'src/models/status/enums';

export const StatusRunType = createEnumGuard(Object.values(_Status) as _Status[]);

export const StatusButtonRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	changeable: Boolean,
	processId: String,
	render: Boolean,
	status: StatusRunType,
});

export type StatusButton = Static<typeof StatusButtonRunType>;
